import React from 'react';
import PreLoginSessionCheck from './PreLoginSessionCheck.js';
import PreLoginPage from '../../../views/core/PreLoginPage';
import cambridge from '../../../images/icons/cambridge_home.png';
import raffles from '../../../images/icons/raffles_home.png';
import bbcnews from '../../../images/icons/bbcnews.png';
import nytimes from '../../../images/icons/nytimes.png';
import worldisflat from '../../../images/icons/worldisflat.png';
import nasscom from '../../../images/icons/nasscom.png';

// ES6 class-style
class RecognisedStatic extends PreLoginPage {
  render() {
  	return(
	<div data-p-ga="" id="recognisedStatic">
		<div className="container">
			
			<div className="row">
                <div className="books">     
                    <div className="col-4 collaboration">
                    <p>Academic collaborations</p>                           
                       {/*  <span className="img-wrapper"> 
                        <img src={cambridge} alt="" />
                            <span className="logo-title">University of Cambridge</span>                            
                        </span>                   
                        
                        <span className="img-wrapper">
                        <img src={raffles} alt="" />  
                            <span className="logo-title">Raffles Institution, Singapore</span>                           
                        </span> */}
                         
                        <span className="img-wrapper">
                            <img src={cambridge} alt="University of Cambridge logo" />
                        </span>
                        <span className="img-wrapper">        
                            <img src={raffles} alt=" Raffles Institution, Singapore" />    
                        </span> 
                    </div>
                    <div className="col-4 recognised">                   
                        <p>Featured in</p> 	  
                        <span className="img-wrapper">
                            <a data-ga="Home - Featured In - BBC News" href="http://news.bbc.co.uk/2/hi/south_asia/5203440.stm" target="_blank"><img src={bbcnews} alt="BBC News logo" /></a>
                        </span> 
                        <span className="img-wrapper">
                            <a data-ga="Home - Featured In - NewYork Times" href="https://www.nytimes.com/2005/09/16/opinion/still-eating-our-lunch.html?_r=1" target="_blank"><img src={nytimes} alt="The New York Times logo" /></a>
                        </span>
                    </div>     
                    <div className="col-4 recognised"> 
                        <p>Recognised by</p> 	    
                        <span className="img-wrapper">
                            <a data-ga="Home - Featured In - World is Flat" href={this.getUrlFor("IFRAME_DOMAIN")+"/staticfiles/Thomas-FriedMan.pdf"} target="_blank"><img src={worldisflat} alt="The World Is Flat" /></a>
                        </span>                        
                        <span className="img-wrapper">
                            <a data-ga="Home - Featured In - NASSCOM" href={this.getUrlFor("IFRAME_DOMAIN")+"/staticfiles/NASSCOM-Award.png"} target="_blank"><img src={nasscom} alt="Nasscom Emerge 50 2011" /></a>
                        </span>   
                    </div>
				</div>
			</div>
		</div>
	</div>
  	);
  }
}

export default RecognisedStatic;


// WEBPACK FOOTER //
// ./src/prelogin/src/components/RecognisedStatic.js